function Login() {
  return(
    <h1>Welcome to Super admin Login</h1>
  );
}

export default Login